// extracted by mini-css-extract-plugin
export default {"container":"productDetailsPage_container__atQFN","btnContainer":"productDetailsPage_btnContainer__0x6rO"};